import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AnimeCard from '../components/AnimeCard';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

const TABS = [
  { key: 'all',       label: 'Todos' },
  { key: 'watching',  label: 'Viendo' },
  { key: 'completed', label: 'Completado' },
  { key: 'paused',    label: 'En pausa' },
  { key: 'dropped',   label: 'Dropeado' },
  { key: 'pending',   label: 'Pendiente' },
];

const STATUS_ICONS = {
  watching:  '👁️',
  completed: '✅',
  paused:    '⏸️',
  dropped:   '❌',
  pending:   '📋',
};

export default function MyList() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [tab,     setTab]     = useState('all');
  const [data,    setData]    = useState({ all: [], grouped: {} });
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  useEffect(() => {
    if (!user) {
      navigate('/', { replace: true });
    }
  }, [user, navigate]);

  const fetchList = () => {
    const token = localStorage.getItem('token');
    setLoading(true);
    fetch(`${API_URL}/user/anime-status`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => r.json())
      .then((d) => setData(d))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (user) fetchList();
  }, [user]);

  if (!user) return null;

  const { all = [], grouped = {} } = data;
  const watching  = grouped.watching?.length  || 0;
  const completed = grouped.completed?.length || 0;
  const paused    = grouped.paused?.length    || 0;
  const dropped   = grouped.dropped?.length   || 0;
  const pending   = grouped.pending?.length   || 0;

  const tabItems = tab === 'all' ? all : (grouped[tab] || []);

  return (
    <div className="mylist-page">
      <div className="mylist-header">
        <h1>Mi lista</h1>
        <p>Tu colección personal de anime</p>
      </div>

      {/* Stats */}
      <div className="mylist-stats">
        <div className="mylist-stat"><span className="mylist-stat__num">{watching}</span><span className="mylist-stat__lbl">Viendo</span></div>
        <div className="mylist-stat"><span className="mylist-stat__num">{completed}</span><span className="mylist-stat__lbl">Completados</span></div>
        <div className="mylist-stat"><span className="mylist-stat__num">{paused}</span><span className="mylist-stat__lbl">En pausa</span></div>
        <div className="mylist-stat"><span className="mylist-stat__num">{dropped}</span><span className="mylist-stat__lbl">Dropeados</span></div>
        <div className="mylist-stat"><span className="mylist-stat__num">{pending}</span><span className="mylist-stat__lbl">Pendientes</span></div>
      </div>

      {/* Tabs */}
      <div className="mylist-tabs">
        {TABS.map((t) => {
          const count = t.key === 'all' ? all.length : (grouped[t.key]?.length || 0);
          return (
            <button
              key={t.key}
              className={`mylist-tab${tab === t.key ? ' mylist-tab--active' : ''}`}
              onClick={() => setTab(t.key)}
            >
              {t.label}
              {count > 0 && <span className="mylist-tab__count">{count}</span>}
            </button>
          );
        })}
      </div>

      {error && <div className="state-center state-error">{error}</div>}

      {loading ? (
        <div className="dir-grid" style={{ padding: '1.5rem 2.5rem' }}>
          {Array.from({ length: 12 }).map((_, i) => (
            <div key={i} className="acard" style={{ opacity: 0.45 }}>
              <div style={{ aspectRatio: '2/3', background: 'var(--bg-elevated)' }} />
              <div className="acard__meta">
                <div style={{ height: 10, background: 'var(--bg-elevated)', borderRadius: 4, marginBottom: 6 }} />
                <div style={{ height: 8, width: '60%', background: 'var(--bg-elevated)', borderRadius: 4 }} />
              </div>
            </div>
          ))}
        </div>
      ) : tabItems.length === 0 ? (
        <div className="mylist-empty">
          <p>No tenés animes en esta categoría.</p>
          <button className="btn-play" onClick={() => navigate('/directorio')}>
            Explorá el directorio
          </button>
        </div>
      ) : (
        <div className="dir-grid mylist-grid">
          {tabItems.map((anime) => (
            <div key={anime.id} className="mylist-card-wrap">
              <AnimeCard anime={anime} currentStatus={anime.status} />
              <div className="mylist-status-badge">
                {STATUS_ICONS[anime.status]} {TABS.find((t) => t.key === anime.status)?.label}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
